export const breakpoint_small = '@media (max-aspect-ratio: 1/1)'; // When width < height
export const breakpoint_small_landscape = '@media (min-width: 640px) and (max-width: 767.98px)'; // Small phones in landscape mode
export const breakpoint_medium = '@media (min-width: 768px) and (max-width: 1023.98px)'; // Tablets and small desktops
export const breakpoint_large = '@media (min-width: 1024px) and (max-width: 1279.98px)'; // Laptops and larger tablets
export const breakpoint_xLarge = '@media (min-width: 1280px)'; // Desktops and large screens

